// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lang[data-v-82c5f6e8] {\n  width: 100%;\n}\n.lang[data-v-82c5f6e8] .el-form-item__content {\n  width: 79%;\n}", ""]);
// Exports
module.exports = exports;
